const getFormApiURL = () =>
  process.env.GATSBY_DEVELOPMENT
    ? 'http://localhost:3000/api/mail-serv'
    : 'https://alemana-consultant.com/api/mail-serv';

export { getFormApiURL };
